export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.NavigationBar'

export const REPORT_NAVIGATION_TOGGLE_EXPANDED = 'REPORT_NAVIGATION_TOGGLE_EXPANDED'
export const REPORT_NAVIGATION_SET_POSITION = 'REPORT_NAVIGATION_SET_POSITION'
